var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "connector-info-card",
      style: `--card-color: ${_vm.color};`,
    },
    [
      _c("div", { staticClass: "connector-info-card-content" }, [
        _c("div", [
          _vm.title || _vm.$slots["title-tooltip"]
            ? _c(
                "div",
                { staticClass: "connector-info-card-content-title" },
                [
                  _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
                  _vm.$slots["title-tooltip"]
                    ? [
                        _c("i", {
                          staticClass: "fa-solid fa-circle-info",
                          attrs: {
                            id: "connector-info-card-content-tooltip-" + _vm.id,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              target:
                                "connector-info-card-content-tooltip-" + _vm.id,
                              "custom-class":
                                "connector-info-card-content-tooltip",
                            },
                          },
                          [_vm._t("title-tooltip")],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "connector-info-card-content-value" }, [
            _vm._v(_vm._s(_vm.value)),
          ]),
        ]),
        _vm._v(" "),
        _vm.icon
          ? _c("div", { staticClass: "connector-info-card-content-icon" }, [
              _c("i", { class: _vm.icon }),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }